import React from 'react'
import guy from '../../images/image (35).png'
import { useLanguage } from "../../Providers/LanguageContext";
const AboutBanner = () => {
    const { language, currentLanguage } = useLanguage();
    return (
        <>
            <div className="general_user_banner_Wrapper" style={{
                
                paddingBottom: '50px'
            }}>

                <div className="container-fluid general_user_banner_content_wrapper" style={{
                    paddingTop: '70px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div className="left_banner_content" style={{
                        marginTop: '-70px'
                    }}>
                        <h1>{language.about_us}</h1>
                        <h6 style={{
                            fontSize: '17px',
                            lineHeight: '25px',
                            marginTop: '-20px'
                        }}>{language.about_give_user}</h6>
                    </div>
                    <div className="right_banner_content">
                        <img src={guy} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutBanner